import storage from '../factory/StorageFactory';
import config from '../appconfig/config.json';
import mData from '../hybriddata/mainform.json';

const dynamicSort = (property) =>{
    var sortOrder = 1;

    if(property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }

    return function (a,b) {
        if(sortOrder == -1){
            return b[property].localeCompare(a[property]);
        }else{
            return a[property].localeCompare(b[property]);
        }        
    }
}

const mask = (word,num) =>  {
    if(word){
        if (word.length <= num) {
            return word;
          } else {
            var masked = word.substring(0, word.length - num).replace(/[a-z\d]/gi,"X") + 
            word.substring(word.length - num, word.length)
            return masked;
          }
    }
}

const getObjInArray = (iValue, array) => {
    let result = {};
    if(iValue !== null){
        try {
            result = array.find( ({ value }) => value === iValue);
            if(result === undefined){
                return {value:'',label:''};
            }
            
            return result;
        }
        catch(e) {
        }
    }
    else {
        return '';
    }
}

const getObjInArrayByLabel = (iLabel, array) => {
    let result = {};
    if(iLabel !== null){
        try {
            result = array.find( ({ label }) => label === iLabel);
            if(result === undefined){
                return {value:'',label:''};
            }
            
            return result;
        }
        catch(e) {
        }
    }
    else {
        return '';
    }
}


const getDesignationbyIDNum = (idNumValue, array) => {
  
    let result = {};
    if(idNumValue !== null) {
        try {
            result = array.find(({ IDNum }) => IDNum === idNumValue);
            if(result === undefined){
                return '';
            }
            return result.Designation;
        }
        catch(e) {
            console.log('getDesignationbyIDNum ',e)
        }
    }
}

const getHolderObjInArray= (idNum, array) => {
    let result = {};
    if(idNum !== null){
        try {
            result = array.find( ({ IDNumber }) => IDNumber === idNum);
            if(result === undefined){
                return {IDNumber:'',Person_Name:''};
            }
            
            return result;
        }
        catch(e) {
        }
    }
    else {
        return '';
    }
}



const getObjInArraybyIDNum = (idNum, array) => {
    let result = {};
    if(idNum !== null){
        try {
            result = array.find( ({ IDNum }) => IDNum === idNum);
            return result;
        }
        catch(e) {
        }
    }
}

const filterArrayByValue = (array, fValue) => {
    let result  = [];
    
    if(fValue !== null){
        result = array.filter(obj => obj.value !== fValue);
    }
     
    return result;
}

const filterArrayByName= (array, name) => {
    let result  = [];
    
    if(name !== null){
        result = array.filter(obj => obj.Name !== name);
    }
     
    return result;
}

const filterArrayById = (array, id) => {
    let result = array.filter(obj => obj.value !== id);
    return result;
}

const checkTokenExpired = () => {
    if(storage.getTokenExpiry()){
        let tokenExpirationDate = new Date(storage.getTokenExpiry());
        let currentDate = new Date();
        if(tokenExpirationDate.getTime() > currentDate){
           // return false;
           return true;
        }
        else {
           // return true;
           return false;
        }
    }
}

const getLabelInArray = (iValue, array) => {
    try{
        if(iValue == null){
            return '';
        }

        const obj = array.find(({ value }) => value === iValue);
        let result = '';
        if(obj){
            result = obj.label;
        }
        return result;
    } catch(ex){

    }
}

const validateNoOfCheckedBox = (data, min, max) => {
    let result = true;
    let count = 0;
    let dataArray =  Object.values(data);
 
    for(let i in dataArray){
        if(dataArray[i] === true){
             count++;
        }
    }

    if( count < min || count > max) {
         result = false;
    }
    else{
        result = true;
    }
    
    return result;
}

const getBaseApiUrl = () => {
    let apiUrl = '';
    switch (config.SERVER_STATUS) {
        case "DEV": apiUrl = config.Domain.DEV
        break;
        case "SIT": apiUrl = config.Domain.SIT 
        break;
        case "UAT": apiUrl = config.Domain.UAT 
        break;
        case "PROD": apiUrl = config.Domain.PROD 
        break;
        case "SIM": apiUrl = config.Domain.SIM 
        break;
        default:
        break;
    }
    return apiUrl;
}

const getPdfUrl = (pdfName) => {
    let url = getBaseApiUrl();
    return url+'/rsme/'+pdfName;
}

const getProductPageUrl = () => {
    let url = getBaseApiUrl();
    return url+'/rsmedigitalfinancing/FinanceDetails';
}

const getConsentPageUrl = () => {
    let url = getBaseApiUrl();
    return url+'/rsmedigitalfinancing/ResumeApplication';
}

const isTokenExpired = () => {
    let isExpired = false;
    const token = storage.getTokenExpiry();
    if(!token){
        isExpired = false;
    }
    else {
        let currentTime, offset,utc,nd;
        let localExpTime = new Date(token).getTime();
        currentTime = new Date();
        utc = currentTime.getTime()+(currentTime.getTimezoneOffset()*60000);
        offset = 8;
        nd = new Date(utc+(3600000*offset));
        if(nd >= localExpTime) {
            isExpired = true;
        }
    }
    return isExpired;
}

const getCountryDesc = (cValue,cArray) => {
    let desc = ''
    if(cValue!==null) {
        const obj = getObjInArray(cValue,cArray);
        if(obj){
            desc = obj.label;
        }
    }
    return desc;
}

const dataURLtoFile = (dataurl, filename) => {
 
    const arr = dataurl.split(',')
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
        
    while(n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    
    return new File([u8arr], filename, {type:mime});
}

const getCurrentTime = () => {
    const today = new Date();
    let h = today.getHours();
    let m = today.getMinutes();
    let s = today.getSeconds();
    m = checkTime(m);
    s = checkTime(s);
    return h+':'+m+':'+s;
}

function checkTime(i) {
    if (i < 10) {i = "0" + i};  // add zero in front of numbers < 10
    return i;
}

const getBranchObjInArray = (iBranchCode, array) => {
    let result = {};
    if(iBranchCode !== null){
        try {
            result = array.find( ({ branchCode }) => branchCode === iBranchCode);
            if(result === undefined){
                return {branchCode:'',branchDescription:'',terminalId:''};
            }
            
            return result;
        }
        catch(e) {
        }
    }
}

const isInvalidState = () => {
    // const sid= storage.getStateId();
    const sid= storage.getRefNo();
    if(sid) {
     return false;
    }
    else {
     return true;
    }
}

const isEmptyObj = (obj)=> {
    for (const prop in obj) {
        if (Object.hasOwn(obj, prop)) {
          return false;
        }
      }
    
      return true;
}

const formatDateYYYYMMDD = (data) => {
    let d = new Date(data), mth = ''+(d.getMonth()+1), day = ''+d.getDate(), yr = d.getFullYear();

    if(mth.length <2) mth ='0'+mth;
    if(day.length < 2) day = '0'+day;

    return [yr, mth, day].join('-');
} 

const formatDateDDMMYYYY = (data) => {
    let d = new Date(data), mth = ''+(d.getMonth()+1), day = ''+d.getDate(), yr = d.getFullYear();
  
    if(mth.length <2) mth ='0'+mth;
    if(day.length < 2) day = '0'+day;
  
    return [day, mth, yr].join('-');
} 

const formatDate2 = (data) => {
 
    if(data){
        let d = new Date(data), mth = ''+(d.getMonth()+1), day = ''+d.getDate(), yr = d.getFullYear();
  
        if(mth.length <2) mth ='0'+mth;
        if(day.length < 2) day = '0'+day;
      
        return [day, mth, yr].join('/');
    }
    return null;

} 

const options = {
    maximumFractionDigits: 2
}    

const decimalRegex = new RegExp(/^[0-9]*(\.[0-9]{0,2})?$/);
const numericRegex = new RegExp(/^[0-9]+$/);
const formatAmount = (a) => {
    let r = '';
    let b = Intl.NumberFormat("en-US", options).format(a);
    if (decimalRegex.test(a) || numericRegex.test(a)) {

        let dpoint = b.indexOf(".") + 1;
        let gap = b.length - dpoint;
        if (gap == 1 && b.length > 1) {
            r = b + '0';
        } else if (dpoint == 0) {
            r = b + '.00';
        } else {
            r = b;
        }
    } else {
        r = b;

    }
    return r;
}

const removeAllSpaces = (value) => {
    if(value) {
      let newStr = value.replace(/\s+/g, '')
      return newStr;
    }
  }

const isDateMorethanOneYrAgo = (inputDate) => {
    const today = new Date();
    const inputDateObj = new Date(inputDate);

    const oneYrAgo = new Date();
    
    oneYrAgo.setFullYear(today.getFullYear()-1);
    
    today.setHours(0, 0, 0, 0);
    inputDateObj.setHours(0, 0, 0, 0);
    oneYrAgo.setHours(0, 0, 0, 0);

    return inputDateObj < oneYrAgo;
}

export default {
    dynamicSort,
    mask,
    getObjInArray,
    filterArrayByValue,
    filterArrayById,
    checkTokenExpired,
    validateNoOfCheckedBox,
    filterArrayByName,
    getObjInArraybyIDNum,
    getLabelInArray,
    getDesignationbyIDNum,
    getPdfUrl,
    getProductPageUrl,
    getConsentPageUrl,
    getBaseApiUrl,
    isTokenExpired,
    dataURLtoFile,
    getCountryDesc,
    getCurrentTime,
    getBranchObjInArray,
    isInvalidState,
    getObjInArrayByLabel,
    isEmptyObj,
    formatDateDDMMYYYY,
    formatDateYYYYMMDD,
    formatDate2,
    formatAmount,
    getHolderObjInArray,
    removeAllSpaces,
    isDateMorethanOneYrAgo
}